import React from 'react';
import vizPresets from '../VisualizationPresets';

type NOPVisualizationType = () => React.ReactElement;

export const NOPVisualizationFactory: (
    vizType: string,
    wireframe?: boolean
) => NOPVisualizationType = (vizType, wireframe = false) => {
    // Get the existing visualization preset config, meta, and schema data
    const { config, includeInToolbar, includeInVizSwitcher } =
        vizPresets.visualizations[vizType];

    // Create the empty-render component
    let NOPVisualization: NOPVisualizationType;
    if (wireframe) {
        // Render of the visualization will be a purple wireframe with the
        // viz type (useful for visually testing that this preset is working)
        NOPVisualization = () =>
            React.createElement(
                'div',
                {
                    'data-test': 'nop-viz-render',
                    style: {
                        border: '1px solid purple',
                        width: '100%',
                        height: '100%',
                    },
                },
                React.createElement('span', null, vizType)
            );
    } else {
        NOPVisualization = () =>
            React.createElement('div', { 'data-test': 'nop-viz-render' });
    }

    // Apply some visualization properties so the Add Charts dropdown still works
    Object.defineProperties(NOPVisualization, {
        config: { value: config },
        includeInToolbar: { value: includeInToolbar },
        includeInVizSwitcher: { value: includeInVizSwitcher },
    });

    // Return the constructed viz preset record
    return NOPVisualization;
};
